import {
    Button,
    Col, Form,
    FormCheck,
    FormControl,
    FormGroup,
    FormLabel,
    Modal,
    ModalBody,
    ModalFooter,
    Row,
} from "react-bootstrap";
import React from "react";
import {ProviderSearch} from "../common/ProviderSearch";
import ModalHeader from "react-bootstrap/ModalHeader";
import {GlobalContext} from "../../GlobalContext";
import {OptionalSelect} from "../common/OptionalSelect";
import {GroupSearch} from "../common/GroupSearch";
import {PatientSearch} from "../common/patient/PatientSearch";

export default class ReferralUploadPatientPicker extends React.Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);

        this.state = {
            patient: null
        }
    }

    patientSelected = (id, obj) => {
        this.setState({patient: obj});
    }

    ok = () => {
        this.props.onSelect(this.state.patient);
    }

    render() {
        return <Modal show={this.props.show} onHide={this.props.onCancel} size={"lg"}>
            <ModalHeader closeButton>Override Selected Patient</ModalHeader>
            <ModalBody>
                <Row>
                    <Col sm={12}>
                        <PatientSearch id={"upload-patientSearch"} patientSelected={this.patientSelected} showNewButton={false} showGoButton={false} clearOnSelect={false}></PatientSearch>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter className={"text-right"}>
                <Button variant="secondary" onClick={this.props.onCancel}>Cancel</Button>
                <Button variant="dark" disabled={this.state.patient === null} onClick={this.ok}>OK</Button>
            </ModalFooter>
        </Modal>
    }
}